// P9 pre-orders (ORD-C-04): orders taken by phone, assigned to a Seller, no price, nothing reserved; delivered by one
// linked sale invoice (post_sale's p_pre_order) or cancelled. Reads from api_v1.v_pre_orders (RLS: a Seller sees theirs).
import { Refusal } from './auth';
import { sendCommand } from './commands';
import { supabase } from './supabase';

export const PRE_ORDERS = ['pre-orders'] as const;

export type PreOrderStatus = 'open' | 'delivered' | 'cancelled';
export interface PreOrderLine {
  product_id: string;
  product: string;
  sku: string | null;
  box_capacity: number | null;
  unit: 'box' | 'piece';
  quantity: number;
}
export interface PreOrder {
  id: string;
  number: string;
  customer_id: string;
  customer: string;
  seller_id: string;
  seller_name: string | null;
  wanted_date: string;
  note: string | null;
  status: PreOrderStatus;
  sale_id: string | null;
  sale_number: string | null;
  created_at: string;
  closed_at: string | null;
  lines: PreOrderLine[];
  pieces: number;
}

function rows<T>(res: { data: unknown; error: { message: string } | null }): T[] {
  if (res.error) throw new Refusal('SERVER_ERROR');
  return (res.data ?? []) as T[];
}

export async function loadPreOrders(): Promise<PreOrder[]> {
  return rows<PreOrder>(
    await supabase.from('v_pre_orders').select('*').order('wanted_date').order('number').limit(500),
  );
}
/** Open pre-orders of one customer assigned to one Seller (the sale sheet's link, ORD-04). */
export async function loadOpenPreOrders(customer: string, seller: string): Promise<PreOrder[]> {
  return rows<PreOrder>(
    await supabase
      .from('v_pre_orders')
      .select('*')
      .eq('customer_id', customer)
      .eq('seller_id', seller)
      .eq('status', 'open')
      .order('wanted_date'),
  );
}

export interface PreOrderInput {
  customer: string;
  seller: string;
  wanted: string;
  lines: { product: string; unit: 'box' | 'piece'; quantity: number }[];
  note?: string | null;
}
export const createPreOrder = (p: PreOrderInput) =>
  sendCommand<{ id: string; number: string }>('create_pre_order', {
    p_customer: p.customer,
    p_seller: p.seller,
    p_wanted: p.wanted,
    p_lines: p.lines,
    p_note: p.note ?? null,
  });
export const cancelPreOrder = (id: string) =>
  sendCommand<{ id: string; number: string }>('cancel_pre_order', { p_pre_order: id });
